(function() {
  // FAQ handler
  document.querySelectorAll('.border.rounded-lg button').forEach(button => {
    button.addEventListener('click', () => {
      const content = button.nextElementSibling;
      const plus = button.querySelector('span:last-child');
      
      // Close all other panels
      document.querySelectorAll('.border.rounded-lg').forEach(panel => {
        if (panel !== button.parentElement) {
          const panelContent = panel.querySelector('div:nth-child(2)');
          const panelPlus = panel.querySelector('span:last-child');
          if (panelContent) {
            panelContent.style.display = 'none';
            panelPlus.textContent = '+';
          }
        }
      });

      // Toggle current panel
      if (content) {
        if (content.style.display === 'none' || !content.style.display) {
          content.style.display = 'block';
          plus.textContent = '-';
        } else {
          content.style.display = 'none';
          plus.textContent = '+';
        }
      }
    });
  });
})();
